import script from "./SecurityUserAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./SecurityUserAvatar.vue?vue&type=script&setup=true&lang=js"

import "./SecurityUserAvatar.vue?vue&type=style&index=0&id=7843d0f6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7843d0f6"]])

export default __exports__